import { Link } from 'react-router-dom';
import { Alert, Card, EmptyState, Icon, Spinner, useAsync } from '@onepos/ui';
import { api } from '../lib/api';
import type { AuditEntry } from '../lib/types';
import { AuditList } from '../components/AuditList';

export function AuditPage() {
  const { data, error, loading, reload } = useAsync(() => api.rpc<AuditEntry[]>('platform_audit_list', { p_limit: 300 }), []);
  return (
    <>
      <header className="cn-page-head">
        <div>
          <h1>Jurnal</h1>
          <p>Platforma jamoasining barcha amallari — kim, qachon, qaysi restoranda</p>
        </div>
        <button type="button" className="op-btn op-btn--secondary op-btn--sm" onClick={reload} disabled={loading}>
          <Icon name="refresh" /> Yangilash
        </button>
      </header>
      {error && <Alert tone="danger">{error.message}</Alert>}
      <Card>
        {loading && !data ? (
          <Spinner />
        ) : data && data.length === 0 ? (
          <EmptyState title="Jurnal bo‘sh">Restoran yaratilgach, amallar shu yerda ko‘rinadi.</EmptyState>
        ) : data ? (
          <AuditList
            items={data}
            renderTenant={(e) =>
              e.tenant_id ? <Link to={`/restoranlar/${e.tenant_id}`}>{e.tenant_name ?? 'Restoran'}</Link> : null
            }
          />
        ) : null}
      </Card>
    </>
  );
}
